<script>
  import { v4 as uuidv4 } from "uuid";
  import { onMount } from "svelte";
  import { gsap } from "gsap";

  const componentId = "photos-light__" + uuidv4();

  onMount(() => {
    setTimeout(() => {
      gsap.from("#" + componentId + " .photos-light__image-1", {
        yPercent: -30,
        ease: "none",
        scrollTrigger: {
          trigger: "#" + componentId,
          end: "top 50%",
          scrub: true,
        },
      });
      gsap.from("#" + componentId + " .photos-light__image-2", {
        xPercent: -20,
        yPercent: 40,
        ease: "none",
        scrollTrigger: {
          trigger: "#" + componentId,
          end: "top 75%",
          scrub: true,
        },
      });
      gsap.from("#" + componentId + " .photos-light__image-3", {
        xPercent: 40,
        yPercent: -20,
        ease: "none",
        scrollTrigger: {
          trigger: "#" + componentId,
          scrub: true,
        },
      });
      gsap.from("#" + componentId + " .photos-light__image-4", {
        xPercent: -10,
        yPercent: 40,
        ease: "none",
        scrollTrigger: {
          trigger: "#" + componentId,
          scrub: true,
        },
      });
    }, 300);
  });
</script>

<div class="photos-light" id={componentId}>
  <div class="photos-light__image-1">
    <img src="https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/photo_light_1.jpg" />
  </div>
  <div class="photos-light__image-2">
    <img src="https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/photo_light_2.jpg" />
  </div>
  <div class="photos-light__image-3">
    <img src="https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/photo_light_3.jpg" />
  </div>
  <div class="photos-light__image-4">
    <img src="https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/photo_light_4.jpg" />
  </div>
</div>

<style lang="scss">
  .photos-light {
    padding: 25% 0 65%;
    position: relative;

    img {
      max-width: 100%;
    }

    &__image-1 {
      width: 100%;
      z-index: 1;
    }

    &__image-2 {
      position: absolute;
      left: 10%;
      right: 50%;
      top: 0;
      width: auto;
      z-index: 2;
    }

    &__image-3 {
      position: absolute;
      top: 55%;
      width: 50%;
      z-index: 3;
    }

    &__image-4 {
      left: 40%;
      position: absolute;
      top: 80%;
      width: 50%;
      z-index: 4;
    }
  }
</style>
